import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AllCampaignsLoadFulfilledAction } from '../../domains/allCampaigns/loadActions.types';
import { CampaignsListLoadMoreFulfilledAction } from '../../domains/allCampaigns/loadMoreAllCampaignsActions.types';
import { CampaignCreateFulfilledAction } from '../../domains/campaignCreation/actions.types';
import { CampaignEditFulfilledAction } from '../../domains/campaignEdit/actions.types';
import { CampaignLoadFulfilledAction } from '../../domains/campaigns/actions.types';
import { MyLeaderSponsoredCampaignsLoadFulfilledAction } from '../../domains/myLeaderSponsoredCampaigns/actions.types';

import { CampaignTargetEntitiesMap } from './types';

export type CampaignTargetEntitiesAction =
  | CampaignCreateFulfilledAction
  | CampaignLoadFulfilledAction
  | CampaignEditFulfilledAction
  | MyLeaderSponsoredCampaignsLoadFulfilledAction
  | AllCampaignsLoadFulfilledAction
  | CampaignsListLoadMoreFulfilledAction;

const initialState: CampaignTargetEntitiesMap = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<CampaignTargetEntitiesMap, CampaignTargetEntitiesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN.CREATE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignTargetEntities);
    case 'CAMPAIGN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignTargetEntities);
    case 'CAMPAIGN.EDIT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignTargetEntities);
    case 'MY_LEADER_SPONSORED_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignTargetEntities);
    case 'ALL_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignTargetEntities);
    case 'ALL_CAMPAIGNS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignTargetEntities);
    default:
      return state;
  }
};

export default reducer;
